angular.module('bmsApp.directives').factory('ActivityColourSvc', [
	'CRUDSvc',
	'ACTIVITY_COLOUR_API', function (
		CRUDSvc,
		ACTIVITY_COLOUR_API) {

	return {
		options: function () {
			return CRUDSvc.get(ACTIVITY_COLOUR_API.OPTIONS);
		}
	};

}]).constant('ACTIVITY_COLOUR_API', {
	OPTIONS: 'api/activityColour/options'
});
